import buildWhatsappMessage from './buildWhatsappMessage';

export default function appendWhatsappProtocolToLink(
  url: string,
  protocolId: string,
) {
  const parsedUrl = new URL(url);
  const currentMessage = parsedUrl.searchParams.get('text') ?? '';

  parsedUrl.searchParams.set(
    'text',
    buildWhatsappMessage({ message: currentMessage, protocolId }),
  );

  return parsedUrl.toString();
}
